module.exports = __webpack_public_path__ + "static/media/fi-rr-envelope.624233a5.svg";